import { z } from 'zod'

export const deleteAccountFormSchema = z
  .object({
    currentPassword: z.string(),
  })
  .refine(
    (values) => {
      const { currentPassword } = values
      return !!currentPassword
    },
    {
      message: 'Please enter the current password.',
      path: ['currentPassword'],
    }
  )
